import { UseModal } from "@/components/root/modal";
import RiskyUsersPolicyScriptModal from "@/views/customize/in-motion/security-policies/risky-users/RiskyUsersPolicyScriptModal.vue";
import MassDownloadPolicyScriptModal from "@/views/customize/in-motion/security-policies/mass-download/MassDownloadPolicyScriptModal.vue";
import AskForJustificationPolicyScriptModal from "@/views/customize/in-motion/security-policies/ask-for-justification/AskForJustificationPolicyScriptModal.vue";

const get_default_label_to_open_policy = async () => {
  const { SharedState } = await import("@/common/state");
  const label = SharedState.l0InfoTypes.value.find(
    (d) => d.id !== SharedState.default_label_id.value
  )!;
  return label;
};

export const POLICY_SCRIPTS: Record<string, () => Promise<boolean>> = {
  // Automate sensitivity labels
  "a88991f2-de84-434c-a575-0d32a788366d": async () => {
    const router = await import("@/router");
    router.default().push({ name: "MIP" });
    return true;
  },

  // Ask for justification for event with Financial information
  "423ac7a6-3e1a-4d11-b916-8c8ffec0a560": async () => {
    const label = await get_default_label_to_open_policy();
    await UseModal().show(AskForJustificationPolicyScriptModal, {
      label_id: label.id,
      label_name: label.labelName,
    });
    return true;
  },
  // Mass download users with Financial information
  "a401bb70-31b8-4211-9b99-2b7803dea4f5": async () => {
    const label = await get_default_label_to_open_policy();
    await UseModal().show(MassDownloadPolicyScriptModal, {
      label_id: label.id,
      label_name: label.labelName,
    });
    return true;
  },
  // Educate risky users with Financial information
  "ed0d5c78-0012-40ed-af48-9a754d2e1dcf": async () => {
    const label = await get_default_label_to_open_policy();
    UseModal().show(RiskyUsersPolicyScriptModal, {
      label_id: label.id,
      label_name: label.labelName,
    });
    return true;
  },
};
